// src/store/modules/settings.js
import axios from 'axios';

export const state = () => ({
    values: {},        // holds boolean flags per key
    initialized: {},   // tracks which keys have been fetched
});

export const mutations = {
    SET_SETTING(state, { key, value }) {
        state.values[key] = value;
        state.initialized[key] = true;
    },
};

export const actions = {
    async fetchSetting({ state, commit }, key) {
        // guard: only fetch once per key
        if (state.initialized[key]) return;

        const { data } = await axios.get(`/api/system-settings/${key}`);
        // data payload is { [key]: value }
        commit('SET_SETTING', { key, value: data[key] });
    },
};

export const getters = {
    // dynamic getter: returns boolean or false
    getSetting: (state) => (key) => {
        return state.values[key] ?? false;
    },

    isInitialized: (state) => (key) => Boolean(state.initialized[key]),
};